var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderConfrontation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 7.33333V2.55L0.95 4.26667L0 3.33333L3.33333 0L6.66667 3.33333L5.71667 4.26667L4 2.55V7.33333H2.66667ZM7.33333 13.3333L4 10L4.95 9.06667L6.66667 10.7833V6H8V10.7833L9.71667 9.06667L10.6667 10L7.33333 13.3333Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderConfrontation);
export default __webpack_public_path__ + "static/media/header-confrontation.1680d7e6a8db90d6e0b0443ef905ca9b.svg";
export { ForwardRef as ReactComponent };